// A one-off burst of small dots for a goal hit or a new record. Decorative; hidden for reduced motion.
const DOTS = 14;

export const Burst = () => (
  <span className="mt-burst" aria-hidden="true">
    {Array.from({ length: DOTS }, (_, index) => (
      <span key={index} style={{ '--mt-burst-angle': `${(360 / DOTS) * index}deg`, '--mt-burst-delay': `${(index % 3) * 40}ms` }} />
    ))}
  </span>
);
